import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PositionForm } from "../components/cashflow/PositionForm";
import { useAccounts } from "../hooks/accounts";
import { useCreatePosition } from "../hooks/cashflow";
import type { CreatePositionInput } from "../lib/cashflow";
import { mapCashflowError } from "../lib/cashflow-errors";

export function CashflowNew() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const accountsQuery = useAccounts({ active: "true" });
  const create = useCreatePosition();
  const [serverError, setServerError] = useState<string | undefined>();

  async function handleSubmit(input: CreatePositionInput) {
    setServerError(undefined);
    try {
      const pos = await create.mutateAsync(input);
      nav(`/cashflow/${pos.id}`);
    } catch (err) {
      const code =
        err instanceof Error && "code" in err ? (err as { code: string }).code : undefined;
      setServerError(
        code ? (t(mapCashflowError(code)) ?? t("errors.unknown")) : t("errors.unknown"),
      );
    }
  }

  return (
    <div className="space-y-4 max-w-xl">
      <h1 className="text-2xl font-bold">{t("cashflow.new.title")}</h1>
      <PositionForm
        mode="create"
        accounts={accountsQuery.data?.accounts ?? []}
        onSubmit={(input) => handleSubmit(input as CreatePositionInput)}
        submitting={create.isPending}
        serverError={serverError}
      />
    </div>
  );
}
